export const lyric02 = `Ooh-ooh
Ah-ah-ah-ah-ah
Brown guilty eyes and little white lies
Yeah, I played dumb but I always knew
That you'd talk to her, maybe did even worse
I kept quiet so I could keep you
And ain't it funny
How you ran to her
The second that we called it quits?
And ain't it funny
How you said you were friends?
Now it sure as hell don't look like it
You betrayed me
And I know that you'll never feel sorry
For the way I hurt, yeah
You'd talk to her
When we were together
Loved you at your worst
But that didn't matter
It took you two weeks
To go off and date her
Guess you didn't cheat
But you're still a traitor
Now you bring her around
Just to shut me down
Show her off like she's a new trophy
And I know if you were true
There's no damn way that you
Could fall in love with somebody that quickly
Ain't it funny
All the twisted games
All the questions you used to avoid?
Ain't it funny?
Remember I brought her up
And you told me I was paranoid
You betrayed me
And I know that you'll never feel sorry
For the way I hurt, yeah
You'd talk to her
When we were together
Loved you at your worst
But that didn't matter
It took you two weeks
To go off and date her
Guess you didn't cheat
But you're still a traitor
God, I wish that you had thought this through
Before I went and fell in love with you
(Ah-ah-ah)
When she's sleeping in the bed we made
Don't you dare forget about the way
You betrayed me
'Cause I know that you'll never feel sorry
For the way I hurt, yeah
You'd talk to her
When we were together
You gave me your word
But that didn't matter
It took you two weeks
To go off and date her
Guess you didn't cheat
But you're still
You're still a traitor (ah-ah-ah)
Yeah, you're still a traitor
Ooh-ooh-ooh
God, I wish that you had thought this through
Before I went and fell in love with you`